import {ThemePalette} from '@angular/material/core';
import {OptionalTableColumn} from '../common/optional-table-column';

export class MesswertTableFilter {

  static SOURCE_FILTER: MesswertTableFilter = {
    name: 'Alle',
    completed: false,
    color: 'primary',
    subSources: [
      {name: 'DWD', completed: true, color: 'accent'},
      {name: 'MG', completed: false, color: 'accent'},
    ]
  };

  static STREET_TYPE_FILTER: MesswertTableFilter = {
    name: 'Straße',
    completed: false,
    color: 'primary'
  };

  static REGIONS_FILTER: MesswertTableFilter[] = [
    {
      name: 'Deutschland',
      completed: true,
      color: 'primary'
    },
    {
      name: 'Europa',
      completed: false,
      color: 'primary'
    },
    {
      name: 'Welt',
      completed: false,
      color: 'primary'
    }
  ];

  name: string;
  completed: boolean;
  color: ThemePalette;
  subSources?: MesswertTableFilter[];

}

export class MesswertTableColumn extends OptionalTableColumn {

  static OPTIONAL_COLUMNS: MesswertTableColumn[] = [
    new MesswertTableColumn('id', 'ID'),
    new MesswertTableColumn('typ', 'Typ'),
    new MesswertTableColumn('luftdruck', 'Luftdruck'),
    new MesswertTableColumn('niederschlagsart', 'Niederschlagsart'),
    new MesswertTableColumn('maxwindboee', 'Windboee'),
    new MesswertTableColumn('sonnenscheindauer', 'Sonnenschein'),
  ];
}

export class ActiveMesswertTableFilter {
  quellen: string;
  region: string;
  hasStreetFilterActive: boolean;
  showValuesOlderThanOneHour: boolean;
}
